<template>
  <ul :class="disabled ? 'ipAdress-not-allow' : 'ipAdress'">
    <li v-for="(item,index) in ipAddress" :key="index">
      <input
        :ref="inputRef"
        v-model="item.value"
        type="text"
        :disabled="disabled"
        @input="checkIpVal(item)"
        @keyup="turnIpPosition(item,index,$event)"
        @blur="setDefaultVal(item)"
      />
      <div></div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'IpAddressInput',
  props: {
    inputRef: {
      type: String,
      default: ''
    },
    ipshow: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ipAddress: [{
        value: ''
      }, {
        value: ''
      }, {
        value: ''
      }, {
        value: ''
      }],
      str: ''
    };
  },
  watch: {
    ipshow: {
      handler(newVal, oldVal) {
        if (newVal !== '') {
          this.ipAddress = newVal.split('.').map(item => {
            return { value: item };
          });
        } else {
          this.ipAddress = this.ipAddress.map(item => ({ value: '' }));
        }
      },
      immediate: true,
      deep: true
    },
    ipAddress: { // 双向数据绑定的value
      handler(newVal, oldVal) {
        if (newVal.map(item => item.value).join('.') === '0.0.0.0') {
          this.str = '';
          this.ipAddress = newVal.map(item => {
            return { value: '' };
          });
          this.$emit('input', this.str);
        } else {
          if (newVal.map(item => item.value).join('.') === '...') {
            this.str = '';
          } else {
            this.str = newVal.map(item => item.value).join('.');
          }
          this.$emit('input', this.str);
        }
      },
      deep: true
    }
  },
  methods: {
    // 检查ip输入为0-255
    checkIpVal(item) {
      // 确保每个值都处于0-255
      let val = item.value;
      // 处理非数字
      val = val.toString().replace(/[^0-9]/g, '');
      val = parseInt(val, 10);
      if (isNaN(val)) {
        val = '';
      } else {
        val = val < 0 ? 0 : val;
        val = val > 255 ? 255 : val;
      }
      item.value = val;
    },
    // 光标位置判断
    turnIpPosition(item, index, event) {
      const self = this;
      const obj = self.$refs[self.inputRef];
      const e = event || window.event;
      if (e.keyCode === 37) { // 左箭头向左跳转，左一不做任何措施
        if (index !== 0 && e.currentTarget.selectionStart === 0) {
          obj[index - 1].focus();
        }
      } else if (e.keyCode === 39) { // 右箭头向右跳转，右一不做任何措施
        if (index !== 3 && e.currentTarget.selectionStart === item.value.toString().length) {
          obj[index + 1].focus();
        }
      } else if (e.keyCode === 8) { // 删除键把当前数据删除完毕后会跳转到前一个input，左一不做任何处理
        if (index !== 0 && item.value === '') {
          obj[index - 1].focus();
        }
      } else if (e.keyCode === 13 || e.keyCode === 32 || e.keyCode === 190) { // 回车键、空格键、冒号均向右跳转，右一不做任何措施
        if (index !== 3) {
          obj[index + 1].focus();
        }
      } else if (item.value.toString().length === 3) { // 满3位，光标自动向下一个文本框
        if (index !== 3) {
          obj[index + 1].focus();
        }
      }
    },
    setDefaultVal(item) {
      // 当input失去焦点，而ip没有赋值时，会自动赋值为空
      const val = item.value;
      if (val === '') {
        item.value = '0';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.ipAdress-not-allow {
  background-color: #f5f7fa;
  border: 1px solid #dcdfe6;
  color: #c0c4cc;
  cursor: not-allowed;
  border-radius: 3px;
  display: flex;
  align-items: center;
}
.ipAdress-not-allow li {
  list-style-type: none;
  position: relative;
  height: 32px;
  margin: 0;
}
ul[class="ipAdress-not-allow"] input[type="text"] {
  border: none;
  width: 100%;
  height: 32px;
  line-height: 32px;
  color: #606266;
  text-align: center;
  background: transparent;
}
.ipAdress-not-allow li div {
  position: absolute;
  bottom: 14px;
  right: 0;
  border-radius: 50%;
  background: #606266;
  width: 2px;
  height: 2px;
}
/*只需要3个div*/
.ipAdress-not-allow li:last-child div {
  display: none;
}
/*取消掉默认的input focus状态*/
.ipAdress-not-allow input:focus {
  outline: none;
}
.ipAdress {
  display: flex;
  align-items: center;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
}
.ipAdress:hover {
  border: 1px solid $main;
}
.ipAdress li {
  list-style-type: none;
  position: relative;
  height: 32px;
  margin: 0;
}
ul[class="ipAdress"] input[type="text"] {
  border: none;
  width: 100%;
  height: 32px;
  line-height: 32px;
  color: #606266;
  text-align: center;
  background: transparent;
}
.ipAdress li div {
  position: absolute;
  bottom: 14px;
  right: 0;
  border-radius: 50%;
  background: #606266;
  width: 2px;
  height: 2px;
}
/*只需要3个div*/
.ipAdress li:last-child div {
  display: none;
}
/*取消掉默认的input focus状态*/
.ipAdress input:focus {
  outline: none;
}
</style>
